import request from '@/utils/request'

// ────────── 登录 ──────────
export function loginCaptcha() {
  return request({ url: '/front/login/captcha', method: 'get' })
}

export function loginSendSms(data) {
  return request({ url: '/front/login/sms-code', method: 'post', data })
}

export function loginBySms(data) {
  return request({ url: '/front/login/by-sms', method: 'post', data })
}

export function loginByPassword(data) {
  return request({ url: '/front/login/by-password', method: 'post', data })
}

export function wxQrCode() {
  return request({ url: '/front/login/wx/qr-code', method: 'get' })
}

export function wxPoll(ticket) {
  return request({ url: '/front/login/wx/poll', method: 'get', params: { ticket } })
}

export function getCurrent() {
  return request({ url: '/front/login/current', method: 'get' })
}

export function getMyPermCodes() {
  return request({ url: '/front/auth/permission/codes', method: 'get' })
}

export function logoutApi() {
  return request({ url: '/front/login/logout', method: 'post' })
}

// ────────── 注册 ──────────
export function registerCaptcha() {
  return request({ url: '/front/register/captcha', method: 'get' })
}

export function registerSendSms(data) {
  return request({ url: '/front/register/sms-code', method: 'post', data })
}

export function registerSmsVerify(data) {
  return request({ url: '/front/register/sms-verify', method: 'post', data })
}

export function registerByPhone(data) {
  return request({ url: '/front/register/phone', method: 'post', data })
}

export function wxAuthUrl() {
  return request({ url: '/front/register/wx/auth-url', method: 'get' })
}

export function registerByWechat(data) {
  return request({ url: '/front/register/wx/bind', method: 'post', data })
}

export function listLibraries(keyword) {
  return request({ url: '/front/register/libraries', method: 'get', params: { keyword } })
}

export function checkPhoneExists(phone) {
  return request({ url: '/front/register/phone-exists', method: 'get', params: { phone } })
}

// ────────── 忘记密码 ──────────
export function forgetCaptcha() {
  return request({ url: '/front/forget-password/captcha', method: 'get' })
}

export function forgetSendSms(data) {
  return request({ url: '/front/forget-password/sms-code', method: 'post', data })
}

export function forgetVerify(data) {
  return request({ url: '/front/forget-password/verify', method: 'post', data })
}

export function forgetReset(data) {
  return request({ url: '/front/forget-password/reset', method: 'post', data })
}
